<template>
  <v-container fluid>
    <v-card class="elevation-3 pa-2">
      <v-card-title>
        <v-icon left color="green darken-2">mdi-microsoft-excel</v-icon>
        Relatório Telemarketing
      </v-card-title>
      <v-card-subtitle>
        Exporta o cadastro de pessoas (Equipe, Nome, Telefone, Assessor) em Excel
        para a central de telemarketing. Use os filtros para refinar.
      </v-card-subtitle>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="select_equipe"
              :items="candidatos"
              item-value="idcandidato"
              item-text="nome_completo"
              label="Equipe"
              prepend-inner-icon="mdi-account-group"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              v-model="select_assessor"
              :items="assessores"
              item-value="id"
              item-text="nome_completo"
              label="Assessor"
              prepend-inner-icon="mdi-account-tie"
              outlined
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" dark depressed @click="exportar">
          <v-icon left>mdi-microsoft-excel</v-icon>
          Exportar Excel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import AclAPI from "./../../api/acl";

export default {
  name: "RelatorioTelemarketing",
  data: () => ({
    candidatos: [{ idcandidato: 0, nome_completo: "Todas as equipes" }],
    assessores: [{ id: 0, nome_completo: "Todos os assessores" }],
    select_equipe: 0,
    select_assessor: 0,
  }),
  mounted() {
    this.carregarFiltros();
  },
  methods: {
    carregarFiltros() {
      const headers = this.Helpers.iniciarRequisicao();

      AclAPI.getCandidatos(headers)
        .then((response) => {
          localStorage.setItem("token", response.data.token);
          this.candidatos = [
            { idcandidato: 0, nome_completo: "Todas as equipes" },
            ...response.data.candidatos,
          ];
        })
        .catch(() => {});

      AclAPI.getAssessoresLista(headers)
        .then((response) => {
          localStorage.setItem("token", response.data.token);
          this.assessores = [
            { id: 0, nome_completo: "Todos os assessores" },
            ...response.data.assessores,
          ];
        })
        .catch(() => {});
    },

    exportar() {
      const equipe = this.select_equipe || 0;
      const assessor = this.select_assessor || 0;
      const idCd = localStorage.getItem("id");

      const url =
        "relatorio_telemarketing?equipe=" +
        equipe +
        "&assessor=" +
        assessor +
        "&id_cd=" +
        idCd;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
  },
};
</script>
